import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from '@components/Layout';
import ErrorBoundary from '@components/ErrorBoundary';
import HomePage from '@routes/home';
import CategoryPage from '@routes/category';
import GamePage from '@routes/game';
import SearchPage from '@routes/search';
import StaticPage from '@routes/static-page';
import { LanguageProvider } from '@lib/i18n';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/privacy" element={<StaticPage slug="privacy" />} />
            <Route path="/terms" element={<StaticPage slug="terms" />} />
            <Route path="/dmca" element={<StaticPage slug="dmca" />} />
            <Route path="/:slug" element={<GamePage />} />
          </Routes>
        </Layout>
      </LanguageProvider>
    </ErrorBoundary>
  );
};

export default App;
